import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { ReactComponent as SearchSvg } from '../../../../images/search.svg';
import { ReactComponent as CancelXSvg } from '../../../../images/cancel-x.svg';
import LocationHelper from '../../../../helpers/location_helper';

export default class AdminDashboardProposalsSearchForm extends Component {
  static propTypes = {
    onResults: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { customerId: '', searchCompleted: false };
  }

  onCancelClick = (e) => {
    e.preventDefault();
    const { onResults } = this.props;
    this.setState({ customerId: '', searchCompleted: false });
    onResults(null);
  };

  onFieldValueChange = (e) => {
    const { target } = e;
    this.setState({ [target.name]: target.type === 'checkbox' ? target.checked : target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    window.open(`${LocationHelper.getUrlForSubdomain('switch')}/customer/${this.state.customerId}/proposal`);
  };

  render() {
    const { customerId, searchCompleted } = this.state;

    return (
      <div className="admin-dashboard-proposals-search-form-container">
        <form
          {...{
            className: 'admin-dashboard-proposals-search-form',
            onSubmit: this.onSubmit,
            name: 'adminDashboardProposalsSearchForm',
          }}
        >
          <input
            {...{
              disabled: searchCompleted,
              name: 'customerId',
              onChange: this.onFieldValueChange,
              placeholder: 'Enter a Customer ID',
              required: true,
              type: 'number',
              value: customerId,
            }}
          />
          {searchCompleted && (
            <button
              {...{ className: 'action-primary action-alt no-left-radius center-content', onClick: this.onCancelClick }}
            >
              <CancelXSvg />
            </button>
          )}
          {!searchCompleted && (
            <button {...{ className: 'action-primary action-alt no-left-radius center-content' }}>
              <SearchSvg />
            </button>
          )}
        </form>
      </div>
    );
  }
}
